module.exports = {"yytx01":{"daobanList":[{"title":"1:是否办理城镇独生子女父母计划生育奖励","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、计划生育奖励扶助对象申报表","state":"必要"},{"name":"2、中华人民共和国结婚证","state":"必要"},{"name":"3、居民身份证","state":"必要"},{"name":"4、本人免冠证件照3张","state":"必要"},{"name":"5、广东省居民户口簿","state":"必要"},{"name":"6、代发金融机构存折或借记卡","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx01.json
// module id = 1300
// module chunks = 0